nextPlanType